import {createEventHandler} from 'recompose';
import {stateGo} from 'redux-ui-router';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/takeUntil';
import {Observable} from 'rxjs/Observable';
import fuse from '../../../_libs/redux-fusion';
import {getUser} from '../../../app/model/reducers/state';
import {isWebBuild, LANDING_VIEW, OPEN_TOK_KEY} from '../../../config/constants';
import {getRouter} from '../../../config/reducers/state';
import {getVideoChatSession} from '../../reducers/state';
import {videoSessionsActions} from '../../redux/videoSessionRequests';
import {commentsStates} from '../../router';
import {VideoChatSessionComponent} from './VideoChatSessionComponent2';
import {containerIds} from './VideoChatSessionView';


// TODO: bind status from request states to Video component to show statuses in-progress, on err, etc
//   - TODO: figure out which statuses we need and add them
const StreamedComponent = (state$, dispatch) => (props$) => {
  const {
    handler: onClickJoin,
    stream: clickJoin$,
  } = createEventHandler();

  /* TODO: add needed session actions  */

  const routerState$ = state$
    .map(getRouter)
    .filter(state => state.currentState && state.currentState.name === commentsStates.videoChat)
    .distinctUntilChanged()
    .takeUntil(props$.last())
    .map(routerState => validateRouterState({
      channelId: routerState.currentParams.channelId,
      sessionId: routerState.currentParams.sessionId,
      onEndCall: buildOnEndCall(dispatch, routerState),
    }));

  const displayName$ = state$
    .map(getUser)
    .map(user => user && user.displayName)
    .distinctUntilChanged();

  const sessionToken$ = state$
    .map(getVideoChatSession)
    .map(state => state.sessionToken)
    .distinctUntilChanged();

  clickJoin$
    .withLatestFrom(routerState$)
    .takeUntil(props$.last())
    .subscribe(([_, routerState]) => {
      if (routerState.channelId && routerState.sessionId) {
        dispatch(videoSessionsActions.getSessionToken({
          channelId: routerState.channelId,
          sessionId: routerState.sessionId,
        }));
      }
    });

  const otCoreOptions$ = Observable
    .combineLatest(
      routerState$.map(state => state.sessionId),
      sessionToken$,
      displayName$,
      (sessionId, sessionToken, displayName) => sessionId && sessionToken && displayName ? builtOtCoreOptions({
        sessionId: sessionId,
        token: sessionToken,
        displayName: displayName,
      }) : null
    );

  otCoreOptions$
    .take(1)
    .takeUntil(props$.last())
    .subscribe(otCoreOptions => {
      if (!otCoreOptions) {
        onClickJoin();
      }
    });

  return props$
    .combineLatest(
      routerState$,
      otCoreOptions$,
      (props, routerState, otCoreOptions) => ({
        ...props,
        ...routerState,
        otCoreOptions,
      }),
    )
    .do(props => console.log('vid con props', props));
};

function validateRouterState(routerState) {
  if (!routerState.sessionId) {
    routerState.isStateInvalid = true;
  }
  return routerState;
}

// TODO: may need to attach the stateGo action to a payload of what to do after the leaveSession action completes?
function buildOnEndCall(dispatch, routerState) {
  // TODO: this applies to cordova webview behavior. browser needs to close the current tab/window instead
  if (isWebBuild()) {
    return () => window.close();
  } else {
    // also check if prevState includes app, otherwise use landing view
    if (routerState.prevState && routerState.prevState.name && routerState.prevState.name.indexOf('app.') === 0) {
      return () => dispatch(stateGo(routerState.prevState.name, routerState.prevParams));
    } else {
      return () => dispatch(stateGo(LANDING_VIEW));
    }
  }
}

export const VideoChatSessionContainer = fuse(StreamedComponent)(VideoChatSessionComponent);

function builtOtCoreOptions(config) {
  const baseOptions = {
    credentials: {
      apiKey: OPEN_TOK_KEY,
      sessionId: config.sessionId,
      token: config.token,
    },
    // A container can either be a query selector or an HTML Element
    streamContainers: (pubSub, type, data, stream) => containerIds[pubSub][type],
    controlsContainer: '#controls',
    packages: ['textChat'],
    communication: {
      callProperties: {
        fitMode: 'contain',
      },
    },
    textChat: {
      name: config.displayName,
      waitingMessage: 'Messages will be delivered when other users arrive',
      container: '#chat',
      alwaysOpen: true,
    },
  };

  if (isWebBuild()) {
    baseOptions.packages.push('screenSharing');
    baseOptions.packages.push('annotation');
    baseOptions.screenSharing = {
      // TODO: inject Chrome extention ID once it has been published
      extensionID: 'plocfffmbcclpdifaikiikgplfnepkpo',
      annotation: true,
      externalWindow: false,
      dev: true,
      screenProperties: {
        insertMode: 'append',
        width: '100%',
        height: '100%',
        showControls: false,
        style: {
          buttonDisplayMode: 'off',
        },
        videoSource: 'window',
        fitMode: 'contain', // Using default
      },
    };

    baseOptions.annotation = {
      absoluteParent: {
        publisher: '.VideoChat-video-container',
        subscriber: '.VideoChat-video-container',
      },
    };
  } else {
    // Overwrite accelerator defaults to cordova plugin will calc from div props
    baseOptions.communication.callProperties.width = null;
    baseOptions.communication.callProperties.height = null;
  }

  return baseOptions;
}



// WEBPACK FOOTER //
// ./src/js/comments/components/VideoChatSession/VideoChatSessionContainer.js